import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { Confirm } from "../../../../assets/Icons";
import { styles } from "./styles";
import Button from "../../../../components/ui/Button";
import { remittanceActions } from "../../state/remittanceSlice";
import { AppStrings } from "../../utils";

const RemittanceConfirmation: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authState = useAppSelector((state) => state.auth);
  const remitterState = useAppSelector((state) => state.remittance);
  const { transactionDetail } = useAppSelector((state) => state.remittance);

  useEffect(() => {
    if (remitterState?.progresStep?.activeStepNumber < 6) {
      navigate("/home", { replace: true });
      dispatch(remittanceActions.resetRemittanceState());
    }
  }, [remitterState?.progresStep?.activeStepNumber]);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Confirm />
      </div>

      <span className={styles.title}>{AppStrings.CONFIRMATION_SCREEN.TITLE}</span>

      <p className={styles.paragraph}>
        {AppStrings.CONFIRMATION_SCREEN.PAYMENT_NOTICE_PREFIX} {transactionDetail?.data?.total_pay}{" "}
        {AppStrings.CONFIRMATION_SCREEN.PAYMENT_NOTICE_SUFFIX}
      </p>

      <p className={styles.paragraphTight}>
        <span className={styles.boldText}>
          {AppStrings.CONFIRMATION_SCREEN.TRANSACTION_ID_LABEL}
        </span>{" "}
        : {transactionDetail?.data?.transactionNumber}
      </p>

      <p className={styles.paragraphTight}>
        {AppStrings.CONFIRMATION_SCREEN.DASHBOARD_TEXT_PREFIX}{" "}
        <span
          onClick={() => {
            navigate("/home");
            dispatch(remittanceActions.resetRemittanceState());
          }}
          className={styles.linkText}
        >
          {AppStrings.CONFIRMATION_SCREEN.DASHBOARD_LINK}
        </span>
        .
      </p>

      <p className={styles.paragraphTight}>
        {AppStrings.CONFIRMATION_SCREEN.UPLOAD_TEXT_PREFIX}{" "}
        <span
          onClick={() => {
            navigate("/history");
            dispatch(remittanceActions.resetRemittanceState());
          }}
          className={styles.linkText}
        >
          {AppStrings.CONFIRMATION_SCREEN.UPLOAD_LINK}
        </span>
        .
      </p>

      <div className={styles.supportText}>
        {AppStrings.CONFIRMATION_SCREEN.SUPPORT_TEXT_PREFIX}{" "}
        <a href="mailto:care@moneyhop.co" className={styles.linkText}>
          {AppStrings.CONFIRMATION_SCREEN.SUPPORT_EMAIL}
        </a>
      </div>

      <Button
        bgColor="bg-primary-1050"
        fontStyle={{
          fontFamily: "",
          fontSize: "text-md",
          fontWeight: "font-medium",
          fontColor: "text-white",
        }}
        borderStyle={{
          borderRadius: "rounded",
        }}
        className={styles.button}
        onClickHandler={() => {
          navigate("/home");
          dispatch(remittanceActions.resetRemittanceState());
        }}
      >
        {AppStrings.CONFIRMATION_SCREEN.GO_HOME}
      </Button>
    </div>
  );
};

export default RemittanceConfirmation;
